import React, { useState, useContext } from 'react'

export interface IsState {
    response?: any,
    loading: Boolean,
    error?: String
}

export interface formData {
    id: any,
    requesterId: any
}

export function useZendeskTicketDescription() {
    const [state, setState] = useState<IsState | null>({
        response: null,
        loading: false,
        error: null
    })

    const getZendeskTicketDescription = async (data: formData) => {
        setState({ response: null, loading: true, error: null })
        try {
            const output = await fetch('/.netlify/functions/zendesk-ticket-comments', {
                method: 'POST',
                body: JSON.stringify(data)
            })
            const res = await output.json()
            console.log("tickets comment", res);

            setState({ response: res, loading: false, error: null })
        } catch (error) {
            setState({
                response: null,
                loading: false,
                error: error
            })
        }
    }

    return [getZendeskTicketDescription, state];
}